import React, { useState, useEffect } from "react";
import TRANSLATIONS from "../translations";
import { subscribeToPush } from "../utils";
import { C, F } from "../theme";
import { Icon } from "../icons";
import { Btn, Card, QRCanvas, Confetti, Callout, Ref } from "./UI";

function Confirm({ order, setView }) {
  const t = TRANSLATIONS.fr;
  const [pushStatus, setPushStatus] = useState("idle");
  const [showConfetti, setShowConfetti] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowConfetti(false), 2500);
    return () => clearTimeout(timer);
  }, []);

  async function handlePushSubscribe() {
    if (!order?.phone) return;
    setPushStatus("subscribing");
    const ok = await subscribeToPush(order.phone);
    setPushStatus(ok ? "subscribed" : "denied");
  }

  const canPush = "Notification" in window && "serviceWorker" in navigator && "PushManager" in window;
  const alreadyGranted = canPush && Notification.permission === "granted";

  useEffect(() => {
    if (alreadyGranted && order?.phone && pushStatus === "idle") {
      subscribeToPush(order.phone).then(ok => setPushStatus(ok ? "subscribed" : "idle")).catch(() => {});
    }
  }, []); // eslint-disable-line

  return (
    <div style={{
      minHeight: "100vh", background: C.bg,
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: 20, paddingBottom: 88,
    }}>
      <Card className="animate-scaleIn" style={{
        maxWidth: 460, width: "100%", textAlign: "center", padding: "28px 24px",
      }}>
        {/* Marque de validation animée — réservation de hauteur pour éviter le saut */}
        <div style={{ minHeight: 68 }}>
          {showConfetti && <Confetti />}
        </div>

        <h1 style={{
          fontSize: F.size["3xl"], fontWeight: F.weight.semi, color: C.ink,
          letterSpacing: "-.02em", marginBottom: 8,
        }}>
          {t.confirmed}
        </h1>
        <p style={{
          fontSize: F.size.md, color: C.inkMuted, lineHeight: 1.6,
          marginBottom: 20, maxWidth: 360, marginLeft: "auto", marginRight: "auto",
        }}>
          {t.confirmedMsg}
        </p>

        {/* Numéro de commande — présentation ticket */}
        <div className="ticket" style={{ marginBottom: 16 }}>
          <div style={{
            background: C.navy, color: C.inkOn, padding: "10px 16px",
            display: "flex", alignItems: "center", justifyContent: "center", gap: 7,
            fontSize: F.size.sm, fontWeight: F.weight.medium,
          }}>
            <Icon name="receipt" size={14} />
            {t.orderNum}
          </div>
          <div className="ticket-dashed" />
          <div style={{ padding: "18px 16px" }}>
            <Ref style={{
              fontSize: F.size["3xl"], fontWeight: F.weight.semi,
              letterSpacing: ".04em", display: "block",
            }}>
              {order?.id}
            </Ref>
            <p style={{ fontSize: F.size.sm, color: C.inkFaint, marginTop: 6 }}>{t.keepNum}</p>

            <div style={{
              marginTop: 16, paddingTop: 16, borderTop: `1px solid ${C.border}`,
              display: "flex", flexDirection: "column", alignItems: "center", gap: 8,
            }}>
              <QRCanvas orderId={order?.id} size={124} />
              <p style={{
                display: "inline-flex", alignItems: "center", gap: 6,
                fontSize: F.size.sm, color: C.inkMuted,
              }}>
                <Icon name="qr" size={13} />
                {t.qrDesc}
              </p>
            </div>
          </div>
        </div>

        {/* Opt-in WhatsApp */}
        <Callout tone="success" icon="chat" title="Vérifiez votre WhatsApp"
          style={{ marginBottom: 12, textAlign: "left" }}>
          Nous vous avons envoyé un message. Répondez « Oui » pour recevoir vos notifications.
        </Callout>

        {/* Opt-in notifications push */}
        {canPush && pushStatus !== "subscribed" && pushStatus !== "denied" && (
          <Callout tone="info" icon="bell" title="Être notifié au départ du collecteur ?"
            style={{ marginBottom: 12, textAlign: "left" }}>
            <div style={{ marginBottom: 10 }}>Suivez son trajet en temps réel sur la carte.</div>
            <Btn small variant="primary" icon="bell"
              onClick={handlePushSubscribe}
              loading={pushStatus === "subscribing"}
              disabled={pushStatus === "subscribing"}>
              {pushStatus === "subscribing" ? "Activation…" : "Activer les notifications"}
            </Btn>
          </Callout>
        )}
        {pushStatus === "subscribed" && (
          <Callout tone="success" icon="success" style={{ marginBottom: 12, textAlign: "left" }}>
            Notifications activées.
          </Callout>
        )}

        <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap", marginTop: 4 }}>
          <Btn icon="track" onClick={() => setView("track")} style={{ flex: 1, minWidth: 150 }}>
            {t.trackMyOrder}
          </Btn>
          <Btn variant="white" icon="home" onClick={() => setView("landing")} style={{ flex: 1, minWidth: 150 }}>
            {t.backHome}
          </Btn>
        </div>
      </Card>
    </div>
  );
}

export default Confirm;
